import { render } from "./FirstScreen.vue?vue&type=template&id=a71ebeba"
import script from "./FirstScreen.vue?vue&type=script&lang=js"
export * from "./FirstScreen.vue?vue&type=script&lang=js"

import "./FirstScreen.vue?vue&type=style&index=0&id=a71ebeba&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__